import { Pipe, PipeTransform } from '@angular/core';
import { SharedUtils } from '../../helpers/shared.utilities';
import { DatePipe } from '@angular/common';
import { CustomDateTimeFormat } from 'sharedweb/app.structs';

@Pipe({
  name: 'nanosecondsToMilliPipe'
})
export class NanosecondsToMilliPipe implements PipeTransform {

  transform(value: any, format?: string, timeZone?: string, subFormat?: string): any {
    // Handle ISO datetime strings
    if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T/)) {
      return new DatePipe('en-US').transform(value, format);
    }

    if (!value || isNaN(value) || value <= 0) {
      return '--';
    }

    const datePipe = new DatePipe('en-us');

    if (format === 'milliSecFormat') {
      let milliSec: number | string = value % 1000;
      if (milliSec === 0) {
        milliSec = milliSec.toString().padEnd(3, "0");
      }
      value = Math.floor(value / 1000);
      if (subFormat) {
        return datePipe.transform(SharedUtils._convertDateTime(value), subFormat, timeZone).concat(`:${milliSec}`);
      }
      return datePipe.transform(SharedUtils._convertDateTime(value), CustomDateTimeFormat.shortDateMediumTime, timeZone).replace(' AM', `:${milliSec} AM`).replace(' PM', `:${milliSec} PM`);
    }

    return datePipe.transform(SharedUtils._convertDateTime(value), format, timeZone);
  }

}
